<template>
    <Icon
        :name="name"
        :width="width"
        :height="height"
        color="transparent"
        :fill-color="color"
        @click="$emit('click')"
    >
        <path
            d="M1.313 24C0.589 24 0 23.411 0 22.687V19.313C0 18.589 0.589 18 1.313 18H2.25V6H1.313C0.589 6 0 5.411 0 4.687V1.313C0 0.589 0.589 0 1.313 0H4.687C5.411 0 6 0.589 6 1.313V2.209L18 4.609V4.313C18 3.589 18.589 3 19.313 3H22.687C23.411 3 24 3.589 24 4.313V7.687C24 8.411 23.411 9 22.687 9H21.75V15H22.687C23.411 15 24 15.589 24 16.313V19.687C24 20.411 23.411 21 22.687 21H19.313C18.589 21 18 20.411 18 19.687V19.391L6 21.791V22.687C6 23.411 5.411 24 4.687 24H1.313ZM4.5 22.5V19.5H1.5V22.5H4.5ZM4.687 18C5.411 18 6 18.589 6 19.313V20.261L18 17.861V16.313C18 15.589 18.589 15 19.313 15H20.25V9H19.313C18.589 9 18 8.411 18 7.687V6.139L6 3.739V4.687C6 5.411 5.411 6 4.687 6H3.75V18H4.687ZM22.5 19.5V16.5H19.5V19.5H22.5ZM22.5 7.5V4.5H19.5V7.5H22.5ZM4.5 4.5V1.5H1.5V4.5H4.5Z"
        />
    </Icon>
</template>

<script>
import Icon from '@/components/icons/Icon'

export default {
    name: 'ZoneIcon',
    components: {
        Icon,
    },
    props: {
        name: {
            type: String,
            default: '',
        },
        width: {
            type: [Number, String],
            default: 18,
        },
        height: {
            type: [Number, String],
            default: 18,
        },
        color: {
            type: String,
            default: '#000',
        },
    },
}
</script>
